module.exports = __webpack_public_path__ + "img/ttdsyatri.62ca933e.png";